import React, { ReactNode, useState } from 'react';

import './FastMode.scss';
import { useTranslation } from 'react-i18next';
import HorsesFastMode from './Components/HorsesFastMode';
import NumbersFastMode from './Components/NumbersFastMode';
import classNames from 'classnames';
import Icon from 'src/components/Icon/Icon';
import SportsFastMode from './Components/SportsFastMode';

interface FastModeProps {
  children?:ReactNode,
  isNumber?: boolean
}

function FastMode({ children, isNumber=false }: FastModeProps) {
  const { t } = useTranslation();
  const [visibleFastMode, setVisibleFastMode] = useState(true);

  return (
    <div className={
      classNames({
        'fast-mode__container': true,
        'fast-mode__container--margin': !visibleFastMode
      })
    }
    >
      <div className="number-bet__title-container">
        <div className="number-bet__lobby-title">{ t('racingDetail.retailFastMode') }</div>
        <div className="number-bet__icon-container" onClick={ () => setVisibleFastMode(!visibleFastMode) }>
          <Icon
            icon="arrow"
            className={
              classNames({
                'number-bet__arrow': true,
                'number-bet__arrow--closed': !visibleFastMode
              })
            }
          />
        </div>
      </div>
      {
        visibleFastMode && <div className={
          classNames({
            'fast-mode': true,
            'fast-mode--numbers': isNumber
          })
        }
        >
          { children }
        </div>
      }
    </div>
  );
}

FastMode.Horses = HorsesFastMode;
FastMode.Numbers = NumbersFastMode;
FastMode.Sports = SportsFastMode;

export default FastMode;
